import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConnectionEditorContainer from './ConnectionEditorContainer';
import { addConnection, checkConnection, clearFields } from 'redux/connections/ConnectionsActions';

const mapStateToProps = ({ connections }) => ({
  creatingConnection: connections.creatingConnection,
  fetchingConnection: connections.fetchingConnection,
  updatingConnection: connections.updatingConnection,
  connection: connections.connection,
  connectionResult: connections.connectionResult,
  checkingConnection: connections.checkingConnection
});

const mapDispatchToProps = dispatch => ({
  connectionsActions: bindActionCreators({ addConnection, checkConnection, clearFields }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionEditorContainer);



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditorContainer/ConnectionEditorConnector.js